/**
 * @module Passage
 */
'use strict';

var Route = require('./lib/route');


module.exports = Route;